"use strict";

/*global  jQuery*/
// jQuery(function ($) {
// $(function () {
//  //読み込みが完了
//  $(window).on('load',function () { 
//    console.log('jQuery Page Loaded.');  
//  });
//  $( '.ore-article table' ).wrap( '<div class="force-responsible"></div>' );

// });
// });


//touchstartに対応してたらtouchstart、してなければclick
let mytap = window.ontouchstart===null?"touchstart":"click";
console.log('touch対応：' + mytap);

// DOM読み込み完了
document.addEventListener('DOMContentLoaded', function(e) {
  console.log('DOM Content Loaded.');

  var menubtn = document.querySelectorAll('.btn-menu')[0];
  var menu = document.querySelectorAll('.site-menu .menu')[0];
  
  var menuParent = document.getElementsByClassName('menu-item-has-children');
  for( var i = 0; i < menuParent.length; i++ ) {
    menuParent[i].insertAdjacentHTML('afterbegin','<div class="toggle-submenu close"></div>');
  }

  // var spmenubtn = document.querySelectorAll('.toggle-submenu');
  var spmenubtn = document.getElementsByClassName('toggle-submenu');
  for (let i = 0; i < spmenubtn.length; i++) {
    // fuga[i]で現在の要素を指定
    spmenubtn[i].addEventListener(mytap, function() {
      spmenubtn[i].classList.toggle('close');
      spmenubtn[i].classList.toggle('open');
    }, false);
  }

  var piyo = document.querySelectorAll('.ore-article table');
  [].forEach.call(piyo, function(a) {
    var div = document.createElement('div');
    div.className = 'force-responsible';
    console.log('aa');
    wrap(a, div);
  });
  // var div = document.createElement('div');
  // div.className = 'force-responsible';
  // [].forEach.call(piyo, function(a) {
  //   console.log('aa');
  //   wrap(a, div);
  // });
  // wrap(piyo, div);
  
  // 関数
  function wrap(element, wrapper) {
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
  }


  // var scroll = new SmoothScroll('a[href*="#"]',{
  //   // header: '[data-scroll-header]'
  // });

}, false);



// 完全に読み込み完了
window.addEventListener('load', function() {
  console.log('Page Loaded.');
});
